export default "__VITE_ASSET__cf50f8e0__"